export const TOKEN_KEY = 'token';
export const ACCOUNT_ID_KEY = 'accountId';
export const MAX_REFRESH_ATTEMPTS = 3;